module.exports = __webpack_public_path__ + "static/media/kuo_shu_wang.097bccc8.jpg";